import type { CosmosDiagnostics } from '@/_contract/diagnostics';

export const DISABLED_DIAGNOSTICS: Readonly<CosmosDiagnostics> = {
    xrLocomotion: false,
    ringGeometry: false,
    cameraGraph: false,
    episode: false,
    derivation: false,
    resources: false,
    cameraInspection: false,
};

const queryNames: Record<keyof CosmosDiagnostics, string> = {
    xrLocomotion: 'xrLocomotionDiagnostics',
    ringGeometry: 'ringGeometryDiagnostics',
    cameraGraph: 'cameraGraphDiagnostics',
    episode: 'episodeDiagnostics',
    derivation: 'derivationDiagnostics',
    resources: 'resourceDiagnostics',
    cameraInspection: 'cameraInspection',
};

export function resolveCosmosDiagnostics(
    developerMode: boolean,
    defaults: Readonly<CosmosDiagnostics>,
    query: URLSearchParams,
): { options: CosmosDiagnostics; errors: string[] } {
    const options = { ...DISABLED_DIAGNOSTICS };
    const errors: string[] = [];
    for (const key of Object.keys(queryNames) as (keyof CosmosDiagnostics)[]) {
        const name = queryNames[key];
        const values = query.getAll(name);
        if (values.length > 1 || (values.length === 1 && values[0] !== '0' && values[0] !== '1')) {
            errors.push(`${name} must occur once with value 0 or 1.`);
            continue;
        }
        options[key] = developerMode && (values.length === 0 ? defaults[key] : values[0] === '1');
    }
    return { options, errors };
}
